import React from "react";
import StyledText from "../StyledComponents/StyledText";
import { useTheme } from "../../middleware/ThemeContext";
import styled from "styled-components";
import { CorporateTheme } from "../../utils/themes";

interface Tab {
  id: number;
  title: string;
  icon?: React.ReactNode;
  active: boolean;
  tabsDisabled?: boolean;
}
interface TabsProps {
  tabs: Tab[];
  onChangeTabs: (id: number) => void;
  className?: string;
  mainClass?: string;
  textSize?: string;
}

export const Tabs: React.FC<TabsProps> = ({
  tabs,
  className,
  mainClass,
  onChangeTabs,
  textSize,
}) => {
  const { theme } = useTheme();
  const handleChangeTabs = (tab: number) => () => {
    onChangeTabs(tab);
  };
  return (
    <TabsCon className={`d-flex cursor-pointer ${mainClass} gap-3  `} theme={theme}>
      {tabs?.map((tab, i) => (
        <StyledText
          fontSize={textSize ? textSize : "14px"}
          fontWeight={tab?.active ? 700 : 600}
          textColor={tab?.active ? 'var(--app-primary-color)' : CorporateTheme.colors.textSecondary}
          key={tab.id || i}
          lineHeight="30px"
          style={{
            cursor: "pointer",
            borderBottom: tab?.active ? `2px solid ${'var(--app-primary-color)'}` : "",
          }}
          className={` ${tab.tabsDisabled ? "class-disable" : ""
            } px-1 py-1 d-flex align-items-center  ${!tab.active && "custom-tab-hover "
            } `}
          onClick={handleChangeTabs(tab?.id)}
        >
          {tab?.icon && (
            <span
              className={`mr-2 ${tab?.active ? "text-primary" : `text-textColor ${className} `
                }`}
            >
              {tab?.icon}
            </span>
          )}
          {tab.title}
        </StyledText>
      ))}
    </TabsCon>
  );
};

const TabsCon = styled.div`
  & .custom-tab-hover {
    // color: ${({ theme }) => CorporateTheme.colors.primary};
    text-decoration: none;
    border-bottom: 2px solid transparent;
    transition: all 0.2s ease;

    &:hover {
      color: ${({ theme }) => CorporateTheme.colors.primary};
      border-bottom: 2px solid ${({ theme }) => CorporateTheme.colors.primary};
    }
  }
`;
